export default class VatNumber {
  id!: string;
  number!: string;
  isValid!: boolean;
  companyName?: string | null;
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
  message?: string | null;
  createdAt!: string;
  updatedAt!: string;

  static fromJson(json: any): VatNumber {
    const v = new VatNumber();
    v.id = String(json.id);
    v.number = String(json.number ?? "");
    v.isValid = Boolean(json.is_valid);
    v.companyName = json.company_name ?? null;
    v.address = json.address ?? null;
    v.postalCode = json.postal_code ?? null;
    v.city = json.city ?? null;
    v.message = json.message ?? null;
    v.createdAt = String(json.created_at ?? "");
    v.updatedAt = String(json.updated_at ?? "");
    return v;
  }
}
